import { useQuery } from "@tanstack/react-query";
import { getUsers } from "../../api/apiUsers";
import i18next from "i18next";

/**
 * Hook لجلب قائمة المستخدمين المفلترة
 * @param {Object} params - Query parameters (page, per_page, search, trashed)
 */
export function useGetUsers(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["users", params, i18next.language],
        queryFn: () => getUsers(params),
        retry: false,
    });

    const users = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, users, meta, refetch };
}